/* Nova Milano Arcade — theme.js */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = (window.NM && window.NM.routes.root) || '/';
  const url = (path) => root.replace(/\/$/, '') + path;

  /* Toast */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* Announcement rotator */
  const items = $$('.announce__item');
  if (items.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* Mobile nav */
  const mobileNav = $('[data-mobile-nav]');
  $$('[data-nav-toggle]').forEach((btn) => btn.addEventListener('click', () => {
    const open = mobileNav.hidden;
    mobileNav.hidden = !open;
    $$('[data-nav-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    document.body.style.overflow = open ? 'hidden' : '';
  }));
  if (mobileNav) mobileNav.addEventListener('click', (e) => {
    if (e.target === mobileNav) $('[data-nav-toggle]').click();
  });

  /* Search toggle */
  const searchBar = $('[data-search-bar]');
  const searchOpen = $('[data-search-open]');
  if (searchBar && searchOpen) searchOpen.addEventListener('click', (e) => {
    e.preventDefault();
    searchBar.hidden = !searchBar.hidden;
    if (!searchBar.hidden) $('input[type="search"]', searchBar).focus();
  });

  /* Cart drawer */
  const drawerSectionId = 'cart-drawer';
  function drawer() { return $('[data-cart-drawer]'); }
  let lastFocus = null;

  function openDrawer() {
    const d = drawer();
    if (!d) { window.location.href = window.NM.routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $('.drawer__panel', d).focus();
  }
  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  async function refreshDrawer(sectionsHtml) {
    let html = sectionsHtml && sectionsHtml[drawerSectionId];
    if (!html) {
      const res = await fetch(url('/?sections=' + drawerSectionId));
      html = (await res.json())[drawerSectionId];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer]', doc);
    const current = drawer();
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
    const cart = await (await fetch(url('/cart.js'))).json();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  async function addItems(items) {
    const res = await fetch(window.NM.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: drawerSectionId })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || window.NM.strings.error);
    await refreshDrawer(data.sections);
    openDrawer();
    toast(window.NM.strings.added);
  }

  async function changeLine(key, quantity) {
    const d = drawer();
    d && d.classList.add('is-busy');
    try {
      const res = await fetch(window.NM.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: drawerSectionId })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || window.NM.strings.error);
      await refreshDrawer(data.sections);
    } catch (err) {
      toast(err.message);
    } finally {
      const dd = drawer();
      dd && dd.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', async (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    const qty = e.target.closest('[data-qty-change]');
    if (qty) { changeLine(qty.dataset.key, parseInt(qty.dataset.qtyChange, 10)); return; }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      quick.classList.add('is-loading');
      try { await addItems([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]); }
      catch (err) { toast(err.message); }
      finally { quick.classList.remove('is-loading'); }
      return;
    }

    const bundle = e.target.closest('[data-add-bundle]');
    if (bundle) {
      bundle.disabled = true;
      const ids = bundle.dataset.addBundle.split(',').filter(Boolean);
      try { await addItems(ids.map((id) => ({ id: Number(id), quantity: 1 }))); }
      catch (err) { toast(err.message); }
      finally { bundle.disabled = false; }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const d = drawer();
      if (d && d.classList.contains('is-open')) closeDrawer();
      if (mobileNav && !mobileNav.hidden) $('[data-nav-toggle]').click();
    }
  });

  /* Product page */
  $$('[data-product]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    const data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const stickyBtn = $('[data-sticky-add]', section);
    const stickyBar = $('[data-sticky-atc]', section);
    const notify = $('[data-notify]', section);
    const dynamic = $('[data-dynamic]', section);
    const priceEl = $('[data-price] .price', section);
    const stickyPrice = $('[data-sticky-price]', section);
    const stock = $('[data-stock]', section);

    // Quantity steppers
    $$('[data-qty-step]', section).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', section);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    }));

    // Variant selection
    function selectedOptions() {
      return $$('.option', section).map((fs, i) => {
        const checked = $('input[data-option="' + i + '"]:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function update() {
      const opts = selectedOptions();
      const v = data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-option-label]', section).forEach((el, i) => { el.textContent = opts[i] || ''; });
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = window.NM.strings.soldOut;
        return;
      }
      idInput.value = v.id;
      const buyable = v.available && v.priceCents > 0;
      addBtn.disabled = !buyable;
      addBtn.textContent = buyable ? window.NM.strings.addToCart : window.NM.strings.soldOut;
      if (stickyBtn) stickyBtn.disabled = !buyable;
      if (notify) notify.hidden = v.available;
      if (dynamic) dynamic.hidden = !v.available;
      if (stock) stock.hidden = !v.available;
      if (priceEl) {
        priceEl.classList.toggle('price--sale', !!v.compare);
        priceEl.innerHTML = '<span class="price__now">' + v.price + '</span>' + (v.compare ? ' <s class="price__was">' + v.compare + '</s>' : '');
      }
      if (stickyPrice) stickyPrice.textContent = v.price.replace(/<[^>]*>/g, '');
      if (v.mediaId) {
        const slide = $('[data-media-id="' + v.mediaId + '"]', section);
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }
    $$('input[data-option]', section).forEach((input) => input.addEventListener('change', update));

    // AJAX add to cart
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      const qtyInput = $('input[name="quantity"]', section);
      try {
        await addItems([{ id: Number(idInput.value), quantity: parseInt(qtyInput.value, 10) || 1 }]);
      } catch (err) { toast(err.message); }
      finally { addBtn.disabled = false; }
    });

    // Sticky add-to-cart (mobile)
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }

    // Gallery thumbs
    const slides = $('[data-slides]', section);
    const thumbs = $$('[data-thumb]', section);
    thumbs.forEach((t) => t.addEventListener('click', (e) => {
      e.preventDefault();
      const target = $('[data-media-id="' + t.dataset.thumb + '"]', section);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }));
    if (slides && thumbs.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === en.target.dataset.mediaId));
          }
        });
      }, { threshold: 0.6 });
      $$('[data-media-id]', slides).forEach((s) => io.observe(s));
    }
  });

  /* Product recommendations */
  $$('[data-recs]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* recommendations are optional */ }
  });


  /* Slideshow */
  $$('[data-slideshow]').forEach((show) => {
    const slides = $$('[data-slide]', show);
    const dots = $$('[data-slide-dot]', show);
    if (slides.length < 2) return;
    let i = 0, timer = null;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
    }
    function start() {
      if (show.dataset.autoplay !== 'true' || reduce) return;
      stop(); timer = setInterval(() => go(i + 1), (parseInt(show.dataset.speed, 10) || 6) * 1000);
    }
    function stop() { clearInterval(timer); }
    const prev = $('[data-slide-prev]', show), next = $('[data-slide-next]', show);
    prev && prev.addEventListener('click', () => { go(i - 1); start(); });
    next && next.addEventListener('click', () => { go(i + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.slideDot, 10)); start(); }));
    show.addEventListener('mouseenter', stop); show.addEventListener('mouseleave', start);
    show.addEventListener('focusin', stop);
    let x0 = null;
    show.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
      x0 = null;
    });
    start();
  });

  /* Product carousels */
  $$('.carousel-section').forEach((sec) => {
    const track = $('[data-carousel]', sec);
    const prev = $('[data-carousel-prev]', sec), next = $('[data-carousel-next]', sec);
    if (!track || !prev || !next) return;
    const step = () => { const item = $('.carousel__item', track); return item ? item.getBoundingClientRect().width + 20 : 300; };
    const sync = () => {
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2 }));
    next.addEventListener('click', () => track.scrollBy({ left: step() * 2 }));
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  /* Tabs (combos, favourites) */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[data-tab]', wrap), panels = $$('[data-panel]', wrap);
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', String(x === t)); });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== t.dataset.tab; });
    }));
  });

  /* Collection: auto-submit sort */
  $$('[data-autosubmit]').forEach((sel) => sel.addEventListener('change', () => sel.form.submit()));
})();
